import { setElementHtml } from '../../../../helpers/generic-js/dom.js'
import { showTableAssociatedEntities } from './grid/show-table.js'

import htmlTemplateEntitiesGrid from './entities-grid.html'
import { addListeners } from './add-listeners.js'

/**
 * Show the associated entities
 * Actions:
 * - Dis-associate
 *
 * View
 * - Token validity
 * - Token info: number of tokens, rights
 *
 * @param {*} params
 */
export async function showAssociatedEntities (params) {
  console.log('showAssociatedEntities', params)

  const containerElement = setElementHtml(params.containerElementId, htmlTemplateEntitiesGrid)
  if (!containerElement) return

  const { browserAppAccount } = params

  // const entitiesResponse = await loadEntities(browserAppAccount.data.appAccountId)
  // console.log('entitiesResponse', entitiesResponse)

  showTableAssociatedEntities({ browserAppAccount })

  addListeners(containerElement, browserAppAccount)

  document.addEventListener('cAssociatedTenant', async () => {
    console.log('cAssociatedTenant', browserAppAccount)
    showTableAssociatedEntities({ browserAppAccount })
  })
  document.addEventListener('cDisassociatedTenant', async () => {
    console.log('cDisassociatedTenant', browserAppAccount)
    showTableAssociatedEntities({ browserAppAccount })
  })
}
